import { useEffect } from 'react';
import { useNetworkStore } from '@/stores/network-store';
import { runCloudSync } from '@/services/cloud-sync.service';

const SYNC_INTERVAL_MS = 60_000;
const FIRST_RUN_DELAY_MS = 5_000;

/**
 * Auto-sync híbrido: mientras la app trabaje contra la BD local (Electron),
 * ejecuta periódicamente el MISMO motor que el botón "Sincronizar Nube"
 * (services/cloud-sync.service.ts). La guarda de concurrencia vive dentro de
 * runCloudSync, así el botón manual y este timer nunca se pisan.
 */
export function useAutoSync() {
  const mode = useNetworkStore((state) => state.mode);

  useEffect(() => {
    if (mode !== 'local' && mode !== 'local_master') return;

    let cancelled = false;

    const run = async (source: 'initial' | 'interval') => {
      if (cancelled) return;
      const result = await runCloudSync({
        onStatus: (msg) => console.log(`[AutoSync:${source}] ${msg}`),
      });

      if (result.ok) {
        if (result.skipped) {
          console.log('[AutoSync] Sincronización ya en curso, se omite esta pasada.');
        } else {
          console.log('[AutoSync] Sincronización automática completada.');
        }
      } else {
        // Sin conexión o error: reintentamos en la siguiente pasada sin molestar al usuario.
        console.warn('[AutoSync] Falló la sincronización automática:', result.message);
      }
    };

    // Primera pasada poco después de abrir la app, y luego cada minuto.
    const firstTimer = setTimeout(() => run('initial'), FIRST_RUN_DELAY_MS);
    const interval = setInterval(() => run('interval'), SYNC_INTERVAL_MS);

    return () => {
      cancelled = true;
      clearTimeout(firstTimer);
      clearInterval(interval);
    };
  }, [mode]);

  return {};
}
